//const API_PROTOCOL = 'http'
//const API_HOST = '127.0.0.1'
//const API_PORT = '8000'

//export const API_BASE_URL = API_PROTOCOL + '://' + API_HOST + ':' + API_PORT
export const API_BASE_URL = 'https://lms-flask-nub63uj4sa-el.a.run.app'
